import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalBody } from 'reactstrap';

import { useSuccessPopupStyles } from './useSuccessPopupStyles';
import tick from '../images/successTick.png';
import techErr from '../images/technical_err.png';

const SuccessPopup = props => {
    const containerRef = useRef(null);
    const reactId = useRef(Math.random().toString(36).slice(2, 9));
    const modalBaseId = props.id || `custom-modal-${reactId.current}`;
    const titleId = props.headText;
    const descriptionId = props.text;
    const classes = useSuccessPopupStyles();

    const handleProceed = () => {
        if (props.prepay) {
            window.location.href = `/prepay/dashboard`;
        } else {
            window.location.href = `/account/dashboard`;
        }
    };
    useEffect(() => {
        if (props.open) {
            const timer = setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.focus();
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [props.open]);

    return (
        <>
            <Modal
                className={classes.successMain}
                wrapClassName={classes.successMainWrapper}
                modalClassName={classes.successMainModal}
                backdropClassName={classes.successMainBackDrop}
                contentClassName={classes.successMainContent}
                isOpen={true}
                toggle={true}
                role='dialog'
                aria-modal='true'
                aria-labelledby={titleId}
                aria-describedby={descriptionId}
                modalTransition={{ timeout: 300 }}
                ref={containerRef}
                centered
            >
                <ModalBody className={classes.successWrapper}>
                    <div className={classes.registerTitleContainer}>
                        <div
                            className={
                                props.flag == 'technical'
                                    ? classes.registerTechTitle
                                    : classes.registerTitle
                            }
                            id={titleId}
                        >
                            {props.headText}
                        </div>
                        {props.flag == 'technical' && <div className={classes.registerLine}></div>}
                    </div>
                    <div
                        className={classes.successBody}
                        id={descriptionId}
                        style={props.flag == 'technical' ? { paddingTop: '16px' } : {}}
                    >
                        <div className={classes.tickWrapper}>
                            {props.flag == 'technical' ? (
                                <img
                                    className={
                                        props.flag == 'technical' ? classes.tech : classes.tick
                                    }
                                    src={techErr}
                                    alt=''
                                    style={props.flag == 'technical' ? { marginTop: '18px' } : {}}
                                />
                            ) : (
                                <img className={classes.tick} src={tick} alt='' />
                            )}
                        </div>
                        <div className={classes.newsTextWrapper}>
                            <div
                                className={classes.newsText}
                                style={props.flag == 'technical' ? { margin: '16px 24px' } : {}}
                            >
                                {props.text}
                            </div>
                        </div>
                    </div>
                    <div className={classes.successFooter}>
                        <button
                            tabindex='0'
                            className={'primary-cta footer-cta'}
                            onClick={handleProceed}
                            aria-label='close-pop-up window'
                            role='button'
                        >
                            {props.flag == 'contact'
                                ? 'Continue'
                                : props.flag == 'technical'
                                ? 'Close'
                                : 'Proceed to my account'}
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default SuccessPopup;
